// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3vWuW","savePackageButton":"ClientWallet_savePackageButton__10Mit"};